export default __webpack_public_path__ + "static/Daniel_Koch_Portrait_2017_1024x800-31d8ac81106e1a2d838e37ad7174eb00.jpg";